
export const visitOutcomes = [
	{label: "Solved virtually", value: "SOLVED_VIRTUALLY"},
	{label: "Recommended in-person but client denied", value: "DENIED_IN_PERSON"},
	{label: "Referred to in-person (ER/UC)", value: "REFERRED_TO_ER_UC"},
	{label: "Referred to in-person (GP)", value: "REFERRED_TO_GP"},
	{label: "Solved virtually, but recommend in-person (GP) if no improvement or gets worse", value: "REFER_TO_REGULAR_DVM"},
	{label: "No show", value: "NO_SHOW"}
];
